import React, { useEffect, useState } from "react";
import "./NoEventDisplay.css";
import { useNavigate } from "react-router-dom";

const NoEventDisplay = ({
  title = "Let's get this party started!",
  description = "Create your Owambe event now and share the invitation link with your guests.",
  buttonText = "Create Event",
  imageType = "desktop",
//   imageCount = 5,
    imageCount = 3, 
}) => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % imageCount);
    }, 3000); 
    return () => clearInterval(interval);
  }, [imageCount]);

  return (
    <div className={`no-event-wrapper ${imageType}`}>
      <div className="no-event-content">
        <div className="no-event-image-carousel">
          {[...Array(imageCount)].map((_, index) => (
            <img
              key={index}
              src={`/images/no-event-${imageType}-${index + 1}.png`}
              alt={`No Event ${index + 1}`}
              className={`no-event-image ${
                index === currentIndex ? "active" : ""
              }`}
            />
          ))}
        </div>
        <img
          src={`/images/no-event.png`}
          alt="No Event"
          className="no-event-image-full"
        />
        <div className="no-event-text-title">{title}</div>
        <div className="no-event-text-description">{description}</div>
        <button
          className="no-event-btn"
          onClick={() => navigate("/createEvent")}
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default NoEventDisplay;
